export const budgetStatuses = {
	CREADO: 1,
	ENVIADO_CONTRAPARTE: 2,
	OBSERVADO_CONTRAPARTE: 3,
	ACEPTADO: 4,
	RECHAZADO: 5,
	PAGADO: 6
};

export default budgetStatuses;
